import React from "react";
import {
    PurchaseOrderHistoryEntry,
    PurchaseOrderPartHistoryEntry,
} from "../../../@types/DRO/PurchaseOrderResponse";
import { ProductOrderApi } from "../../../api/ProductOrder/ProductOrderApi";
import { HistoryColumn, OrderHistory } from "../OrderHistory/OrderHistory";

const orderColumns: HistoryColumn<PurchaseOrderHistoryEntry>[] = [
  { key: "status", label: "Status" },
  {
    key: "amount",
    label: "Amount",
    render: (row) => `₹ ${row.amount?.toFixed(2) ?? "0.00"}`,
  },
  { key: "action", label: "Action" },
  { key: "updatedBy", label: "Updated By" },
  { key: "updatedAt", label: "Updated At" },
];

const partColumns: HistoryColumn<PurchaseOrderPartHistoryEntry>[] = [
  { key: "partName", label: "Part Name" },
  { key: "action", label: "Action" },
  { key: "quantityOrdered", label: "Qty Ordered" },
  { key: "quantityReceived", label: "Qty Received" },
  {
    key: "price",
    label: "Price",
    render: (row) => `₹ ${row.price?.toFixed(2) ?? "0.00"}`,
  },
  {
    key: "tax",
    label: "Tax",
    render: (row) => `${row.tax?.toFixed(2) ?? "0.00"}%`,
  },
  {
    key: "total",
    label: "Total",
    render: (row) => `₹ ${row.total?.toFixed(2) ?? "0.00"}`,
  },
  { key: "updatedBy", label: "Updated By" },
  { key: "updatedAt", label: "Updated At" },
];

interface Props {
  purchaseOrderId: number;
  variant?: "inline" | "dialog";
  open?: boolean;
  onClose?: () => void;
}

export const PurchaseOrderHistory: React.FC<Props> = ({
  purchaseOrderId,
  variant = "inline",
  open = false,
  onClose,
}) => (
  <OrderHistory
    title="Purchase Order History"
    variant={variant}
    open={open}
    onClose={onClose}
    orderColumns={orderColumns}
    partColumns={partColumns}
    fetchHistory={async () => {
      const res = await ProductOrderApi.api.getPurchaseOrderHistory(
        purchaseOrderId
      );
      return {
        orderHistory: res.data.purchaseOrderHistory,
        partHistory: res.data.partHistory,
      };
    }}
  />
);